
import instance from "api/instance";
import { IDeleteReservation, IGetApplicationByPassAndDate, IGetDatesForReservation, IGetTimeSlots, IReserveTimeSlot } from "./types";
import qs from 'query-string'

export const getDatesForReservation: IGetDatesForReservation = (params) => instance.get(`/public/timeslots-branches/dates?${qs.stringify(params, { skipEmptyString: true })}`)

export const getTimeSlots: IGetTimeSlots = (params) => instance.get(`/public/timeslots?${qs.stringify(params, { skipEmptyString: true })}`)

export const reserveTimeSlot: IReserveTimeSlot = (data) => instance.post(`/public/timeslots-branches`, data)

export const getApplicationByDateAndPass: IGetApplicationByPassAndDate = (params) => instance.get(`/public/timeslots-branches?${qs.stringify(params, { skipEmptyString: true })}`)

export const deleteReservation: IDeleteReservation = (data) => instance.post(`/public/timeslots-branches/delete`, data)